const language = {
  UNDEFINED: '미정의',

  AFRIKAANS: '아프리칸스어',
  AMHARIC: '암하라어',
  ARABIC: '아랍어',
  MODERN_STANDARD_ARABIC: '현대 표준 아랍어',

  AZERBAIJANI: '아제르바이잔어',
  BULGARIAN: '불가리아어',
  BENGALI: '벵골어',
  CATALAN: '카탈루냐어',
  CZECH: '체코어',
  DANISH: '덴마크어',
  GERMAN: '독일어',
  GREEK: '그리스어',

  ENGLISH: '영어',
  AMERICAN_ENGLISH: '영어(미국)',
  BRITISH_ENGLISH: '영어(영국)',

  SPANISH: '스페인어',
  EUROPEAN_SPANISH: '스페인어(유럽)',
  LATIN_AMERICAN_SPANISH: '스페인어(라틴아메리카)',

  ESTONIAN: '에스토니아어',
  PERSIAN: '페르시아어',
  FINNISH: '핀란드어',
  FILIPINO: '필리핀어',
  FRENCH: '프랑스어',
  CANADIAN_FRENCH: '프랑스어(캐나다)',

  GUJARATI: '구자라트어',
  HEBREW: '히브리어',
  HINDI: '힌디어',
  CROATIAN: '크로아티아어',
  HUNGARIAN: '헝가리어',
  ARMENIAN: '아르메니아어',
  INDONESIAN: '인도네시아어',
  ICELANDIC: '아이슬란드어',
  ITALIAN: '이탈리아어',
  JAPANESE: '일본어',
  GEORGIAN: '조지아어',
  KAZAKH: '카자흐어',
  KHMER: '크메르어',
  KANNADA: '칸나다어',
  KOREAN: '한국어',
  KIRGHIZ: '키르기스어',
  LAO: '라오스어',

  LITHUANIAN: '리투아니아어',
  LATVIAN: '라트비아어',

  MACEDONIAN: '마케도니아어',
  MALAYALAM: '말라얄람어',
  MONGOLIAN: '몽골어',
  MARATHI: '말라티어',
  MALAY: '말레이어',
  BURMESE: '버마어',
  NEPALI: '네팔어',

  DUTCH: '네덜란드어',

  NORWEGIAN: '노르웨이어',

  PUNJABI: '펀자브어',
  POLISH: '폴란드어',

  PORTUGUESE: '포르투갈어',
  BRAZILIAN_PORTUGUESE: '포르투갈어(브라질)',
  EUROPEAN_PORTUGUESE: '포르투갈어(포르투갈)',

  ROMANIAN: '루마니아어',
  RUSSIAN: '러시아어',
  SINHALA: '싱할라어',
  SLOVAK: '슬로바키아어',
  SLOVENIAN: '슬로베니아어',
  ALBANIAN: '알바니아어',
  SERBIAN: '세르비아어',
  SERBIAN_LATIN: '세르비아어(라틴 문자)',

  SWEDISH: '스웨덴어',
  SWAHILI: '스와힐리어',

  TAMIL: '타밀어',
  TELUGU: '텔루구어',
  THAI: '태국어',
  TURKISH: '튀르키예어',

  UKRAINIAN: '우크라이나어',
  URDU: '우르두어',

  UZBEK: '우즈베크어',
  VIETNAMESE: '베트남어',
  CHINESE: '중국어',
  SIMPLIFIED_CHINESE: '중국어(간체)',
  TRADITIONAL_CHINESE: '중국어(번체)',

  ZULU: '줄루어'
};

export default language;
